
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/89ce65a415860e3da90921dded83bf21/b7b50e3cd2850e25481d88c22295b109.png" 
              alt="BC Robotics" 
              className="h-8 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-400 mb-4 max-w-md">
              Industrial robotics solutions engineered for safety and productivity. 
              Part of the BrainCommerce ecosystem delivering comprehensive workforce operations.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Company</h4>
            <div className="space-y-2">
              <a href="#about" className="block text-gray-400 hover:text-white cursor-pointer transition-colors">About Us</a>
              <a href="#" className="block text-gray-400 hover:text-white cursor-pointer transition-colors">Careers</a>
              <a href="#" className="block text-gray-400 hover:text-white cursor-pointer transition-colors">News</a>
              <a href="#" className="block text-gray-400 hover:text-white cursor-pointer transition-colors">BrainCommerce</a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <div className="space-y-2">
              <a href="#" className="block text-gray-400 hover:text-white cursor-pointer transition-colors">Privacy Policy</a>
              <a href="#" className="block text-gray-400 hover:text-white cursor-pointer transition-colors">Terms of Service</a>
              <a href="#" className="block text-gray-400 hover:text-white cursor-pointer transition-colors">Security</a>
              <a href="#contact" className="block text-gray-400 hover:text-white cursor-pointer transition-colors">Contact</a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 BC Robotics. All rights reserved. Part of BrainCommerce.
          </p>
          <p className="text-gray-400 text-sm mt-2 md:mt-0">
            10F, 509 Teheran Rd. Gangnam gu, Seoul, Korea
          </p>
        </div>
      </div>
    </footer>
  );
}
